// generated by tools/generate-app-commit.mjs — do not edit
export const APP_COMMIT='d0ff7f3';
